import React from 'react';

import {
  COMPONENT_SIZE_DYNAMIC,
  COMPONENT_SIZE_MEDIUM,
  COMPONENT_SIZE_SMALL,
  ComponentSize,
  Orientation,
  ORIENTATION_VERTICAL,
} from '../../../typings/design-tokens';
import { teamFormation } from '../../../typings/formations';
import { IComponent } from '../../../typings/generic-component';
import { formationPlaceType } from '../../../typings/player';

import { IPlayerInFormation } from './match-formation';
import { classNames, createField, createFieldDEBUG } from './match-formation-utils';
import { formations as formationsVertical } from './match-formations-vertical';

import './match-formation-field.scss';

export const componentSizeListCustom: ComponentSize[] = [
  COMPONENT_SIZE_SMALL,
  COMPONENT_SIZE_MEDIUM,
  COMPONENT_SIZE_DYNAMIC,
];
export interface IMatchFormationField extends IComponent {
  customFormationSchema?: IPlayerInFormation[];
  debug?: boolean;
  formation: teamFormation;
  readonly hasImage?: boolean;
  readonly isHome?: boolean;
  readonly orientation?: Orientation;
  readonly players: IFormationPlayer[];
}

export interface IFormationPlayer {
  formationPlace: formationPlaceType;
  fullName: string;
  jerseyNumber: number;
  imageUrl?: string;
  fallbackImageUrl?: string;
  playerPageLink?: string;
}

export const playerNameSlice = (name: string, maxCharLength?: number) =>
  maxCharLength && name.length > maxCharLength ? `${name.slice(0, maxCharLength - 3)}...` : name;

export const getFormationSchema = (fieldOrientation: Orientation) => {
  switch (fieldOrientation) {
    case 'horizontal':
      return formationsVertical; // TODO: change formations to formationsHorizontal when it will be available
    case 'vertical':
      return formationsVertical;
    /* istanbul ignore next: unreachable code */
    default:
      return formationsVertical;
  }
};

const MatchFormationField = ({
  /* istanbul ignore next: default value */ debug = false,
  /* istanbul ignore next: default value */ formation = '442',
  /* istanbul ignore next: default value */ hasImage = false,
  /* istanbul ignore next: default value */ isHome = true,
  /* istanbul ignore next: default value */ orientation = ORIENTATION_VERTICAL,
  /* istanbul ignore next: default value */ players = [],
  /* istanbul ignore next: default value */ size = COMPONENT_SIZE_DYNAMIC,
  customFormationSchema,
}: IMatchFormationField) => {
  const cn = classNames(size);
  return (
    <div className={cn.MatchFormationField}>
      <div className={cn.PlayersContainer}>
        {debug
          ? createFieldDEBUG({ cn, formation, size, orientation, hasImage, customFormationSchema })
          : createField({
              cn,
              customFormationSchema,
              formation,
              hasImage,
              isHome,
              orientation,
              players,
              size,
            })}
      </div>
    </div>
  );
};

export default MatchFormationField;
